'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
var _typeof = require('@babel/runtime/helpers/typeof');
Object.defineProperty(exports, '__esModule', {
	value: true
});
exports.walletFadeIn =
	exports.WalletItemTargeted =
	exports.WalletItemInfoName =
	exports.WalletItemInfoImage =
	exports.WalletItemInfoIcon =
	exports.WalletItemInfo =
	exports.WalletItemConnected =
	exports.WalletItem =
	exports.ModalCard =
	exports.ModalBackground =
	exports.CardRightTitle =
	exports.CardRightItemTitle =
	exports.CardRightItemDescription =
	exports.CardRightItem =
	exports.CardRightIcon =
	exports.CardRightHeader =
	exports.CardRightErrorIcon =
	exports.CardRightErrorDescription =
	exports.CardRightError =
	exports.CardRightDownload =
	exports.CardRightConnectingIcon =
	exports.CardRightCentered =
	exports.CardRight =
	exports.CardHeaderTitle =
	exports.CardHeaderClose =
	exports.CardHeader =
	exports.CardContentWallets =
	exports.CardContentSeparator =
	exports.CardContentMobileHelper =
	exports.CardContent =
		void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require('@babel/runtime/helpers/taggedTemplateLiteral'));
var _styledComponents = _interopRequireWildcard(require('styled-components'));
var _AiFillCloseCircle = require('@react-icons/all-files/ai/AiFillCloseCircle');
var _BiErrorAlt = require('@react-icons/all-files/bi/BiErrorAlt');
var _FaCheckCircle = require('@react-icons/all-files/fa/FaCheckCircle');
var _AiFillLeftCircle = require('@react-icons/all-files/ai/AiFillLeftCircle');
var _colors = require('../../utils/colors');
var _templateObject,
	_templateObject2,
	_templateObject3,
	_templateObject4,
	_templateObject5,
	_templateObject6,
	_templateObject7,
	_templateObject8,
	_templateObject9,
	_templateObject10,
	_templateObject11,
	_templateObject12,
	_templateObject13,
	_templateObject14,
	_templateObject15,
	_templateObject16,
	_templateObject17,
	_templateObject18,
	_templateObject19,
	_templateObject20,
	_templateObject21,
	_templateObject22,
	_templateObject23,
	_templateObject24,
	_templateObject25,
	_templateObject26,
	_templateObject27,
	_templateObject28,
	_templateObject29,
	_templateObject30;
function _getRequireWildcardCache(nodeInterop) {
	if (typeof WeakMap !== 'function') return null;
	var cacheBabelInterop = new WeakMap();
	var cacheNodeInterop = new WeakMap();
	return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
		return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
	})(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
	if (!nodeInterop && obj && obj.__esModule) {
		return obj;
	}
	if (obj === null || (_typeof(obj) !== 'object' && typeof obj !== 'function')) {
		return { default: obj };
	}
	var cache = _getRequireWildcardCache(nodeInterop);
	if (cache && cache.has(obj)) {
		return cache.get(obj);
	}
	var newObj = {};
	var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	for (var key in obj) {
		if (key !== 'default' && Object.prototype.hasOwnProperty.call(obj, key)) {
			var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
			if (desc && (desc.get || desc.set)) {
				Object.defineProperty(newObj, key, desc);
			} else {
				newObj[key] = obj[key];
			}
		}
	}
	newObj['default'] = obj;
	if (cache) {
		cache.set(obj, newObj);
	}
	return newObj;
}
var walletFadeIn = (exports.walletFadeIn = (0, _styledComponents.keyframes)(
	_templateObject || (_templateObject = (0, _taggedTemplateLiteral2['default'])(['\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n']))
));
var ModalBackground = (exports.ModalBackground = _styledComponents['default'].div(
	_templateObject2 ||
		(_templateObject2 = (0, _taggedTemplateLiteral2['default'])([
			'\n\tdisplay: flex;\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tbackdrop-filter: blur(3px);\n\tbackground-color: ',
			';\n\tz-index: 2;\n\tpadding: 2rem;\n\n\t& > * {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tmargin: 0;\n\t\tbox-sizing: border-box;\n\t}\n'
		])),
	function (props) {
		return (0, _colors.addOpacityToColor)(props.theme.primaryColor || '#f1f1f1', 0.24);
	}
));
var ModalCard = (exports.ModalCard = _styledComponents['default'].div(
	_templateObject3 ||
		(_templateObject3 = (0, _taggedTemplateLiteral2['default'])([
			'\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground-color: ',
			';\n\tborder-radius: 1rem;\n\tz-index: 10;\n\tpadding: 2rem;\n\tmax-height: 100%;\n\twidth: 100%;\n\tmax-width: 720px;\n\tmin-height: 440px;\n\tbox-shadow: rgba(14, 15, 16, 0.1) 3px 9px 24px;\n\toverflow-x: hidden;\n\tgap: 2rem;\n\n\t@media (max-width: 480px) {\n\t\tflex-direction: column;\n\t\tgap: 2rem;\n\t\tmin-height: 224px;\n\t}\n'
		])),
	function (props) {
		return props.theme.backgroundColor || '#F1F1F1';
	}
));
var CardHeader = (exports.CardHeader = _styledComponents['default'].div(
	_templateObject4 ||
		(_templateObject4 = (0, _taggedTemplateLiteral2['default'])(['\n\tdisplay: flex;\n\tmin-height: 2rem;\n\twidth: 100%;\n\tjustify-content: space-between;\n']))
));
var CardHeaderTitle = (exports.CardHeaderTitle = _styledComponents['default'].h2(
	_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2['default'])(['\n\tcolor: ', ';\n\tmargin: 0;\n'])),
	function (props) {
		return props.theme.primaryColor || '#121212';
	}
));
var CardHeaderClose = (exports.CardHeaderClose = (0, _styledComponents['default'])(_AiFillCloseCircle.AiFillCloseCircle)(
	_templateObject6 ||
		(_templateObject6 = (0, _taggedTemplateLiteral2['default'])([
			'\n\ttransition: 70ms all ease-out;\n\tcolor: ',
			';\n\twidth: 2rem;\n\theight: 2rem;\n\tcursor: pointer;\n\n\t&:hover {\n\t\ttransform: scale(1.2);\n\t}\n\n\t&:active {\n\t\topacity: 0.75;\n\t}\n'
		])),
	function (props) {
		return props.theme.primaryColor || '#121212';
	}
));
var CardContent = (exports.CardContent = _styledComponents['default'].div(
	_templateObject7 ||
		(_templateObject7 = (0, _taggedTemplateLiteral2['default'])([
			'\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex: 1;\n\tgap: 2rem;\n\twidth: 100%;\n\tmargin: 0;\n'
		]))
));
var CardContentWallets = (exports.CardContentWallets = _styledComponents['default'].div(
	_templateObject8 ||
		(_templateObject8 = (0, _taggedTemplateLiteral2['default'])([
			'\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 1rem;\n\twidth: 280px;\n\tmax-width: 280px;\n\tmin-width: 280px;\n\theight: fit-content;\n'
		]))
));
var CardContentSeparator = (exports.CardContentSeparator = _styledComponents['default'].div(
	_templateObject9 ||
		(_templateObject9 = (0, _taggedTemplateLiteral2['default'])([
			'\n\tdisplay: flex;\n\theight: 100%;\n\twidth: 2px;\n\tborder-radius: 2px;\n\tbackground-color: ',
			';\n\n\t@media (max-width: 480px) {\n\t\tdisplay: none;\n\t}\n'
		])),
	function (props) {
		return (0, _colors.addOpacityToColor)(props.theme.primaryColor || '#121212', 0.16);
	}
));
var CardRight = (exports.CardRight = _styledComponents['default'].div(
	_templateObject10 ||
		(_templateObject10 = (0, _taggedTemplateLiteral2['default'])([
			'\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 2rem;\n\talign-items: center;\n\twidth: 100%;\n\tpadding: 0;\n\n\t@media (max-width: 480px) {\n\t\tpadding: 0;\n\t\tjustify-content: flex-start;\n\t\tmargin: 0;\n\t\tgap: 1rem;\n\t\tflex: 1;\n\t\theight: fit-content;\n\t}\n'
		]))
));
var CardRightCentered = (exports.CardRightCentered = _styledComponents['default'].div(
	_templateObject11 ||
		(_templateObject11 = (0, _taggedTemplateLiteral2['default'])([
			'\n\tanimation: ',
			' 0.15s 0.3s forwards;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tgap: 2rem;\n\talign-items: center;\n\twidth: 100%;\n\tpadding: 0 3rem 0 2rem;\n\topacity: 0;\n\n\t@media (max-width: 480px) {\n\t\tmargin: 2rem 0;\n\t\tdisplay: none;\n\t}\n'
		])),
	walletFadeIn
));
var CardRightItem = (exports.CardRightItem = _styledComponents['default'].div(
	_templateObject12 ||
		(_templateObject12 = (0, _taggedTemplateLiteral2['default'])(['\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 3px;\n\tmax-width: 300px;\n']))
));
var CardContentMobileHelper = (exports.CardContentMobileHelper = _styledComponents['default'].div(
	_templateObject13 ||
		(_templateObject13 = (0, _taggedTemplateLiteral2['default'])(['\n\tdisplay: none;\n\n\t@media (max-width: 480px) {\n\t\tdisplay: flex;\n\t}\n']))
));
var CardRightItemTitle = (exports.CardRightItemTitle = _styledComponents['default'].p(
	_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2['default'])(['\n\tcolor: ', ';\n\tfont-weight: 600;\n\tmargin: 0;\n'])),
	function (props) {
		return props.theme.primaryColor || '#121212';
	}
));
var CardRightItemDescription = (exports.CardRightItemDescription = _styledComponents['default'].p(
	_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2['default'])(['\n\tcolor: ', ';\n\tmargin: 0;\n'])),
	function (props) {
		return props.theme.secondaryColor || '#8C8C8C';
	}
));
var CardRightIcon = (exports.CardRightIcon = (0, _styledComponents['default'])(_AiFillLeftCircle.AiFillLeftCircle)(
	_templateObject16 ||
		(_templateObject16 = (0, _taggedTemplateLiteral2['default'])([
			'\n\tdisplay: none;\n\n\t@media (max-width: 480px) {\n\t\tdisplay: unset;\n\t\twidth: 2rem;\n\t\theight: 2rem;\n\t}\n'
		]))
));
var CardRightError = (exports.CardRightError = _styledComponents['default'].div(
	_templateObject17 ||
		(_templateObject17 = (0, _taggedTemplateLiteral2['default'])([
			'\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 2rem;\n\n\t@media (max-width: 480px) {\n\t\tmargin-bottom: 1rem;\n\t}\n'
		]))
));
var CardRightErrorIcon = (exports.CardRightErrorIcon = (0, _styledComponents['default'])(_BiErrorAlt.BiErrorAlt)(
	_templateObject18 ||
		(_templateObject18 = (0, _taggedTemplateLiteral2['default'])([
			'\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: ',
			';\n\twidth: 72px;\n\theight: 72px;\n'
		])),
	function (props) {
		return props.theme.primaryColor || '#121212';
	}
));
var CardRightErrorDescription = (exports.CardRightErrorDescription = _styledComponents['default'].p(
	_templateObject19 || (_templateObject19 = (0, _taggedTemplateLiteral2['default'])(['\n\tcolor: ', ';\n\ttext-align: center;\n\tmargin: 0;\n'])),
	function (props) {
		return props.theme.secondaryColor || '#8C8C8C';
	}
));
var CardRightTitle = (exports.CardRightTitle = _styledComponents['default'].p(
	_templateObject20 ||
		(_templateObject20 = (0, _taggedTemplateLiteral2['default'])([
			'\n\tcolor: ',
			';\n\ttext-align: center;\n\tfont-weight: 600;\n\tfont-size: 1.25rem;\n\tmargin: 0;\n\twidth: 100%;\n\tgap: 1rem;\n\n\t@media (max-width: 480px) {\n\t\tfont-size: 1.15rem;\n\t\twidth: 100%;\n\t}\n'
		])),
	function (props) {
		return props.theme.primaryColor || '#121212';
	}
));
var CardRightDownload = (exports.CardRightDownload = _styledComponents['default'].a(
	_templateObject21 ||
		(_templateObject21 = (0, _taggedTemplateLiteral2['default'])([
			'\n\tpadding: 0.5rem 1rem;\n\tborder-radius: 30px;\n\tbackground-color: ',
			';\n\tcolor: ',
			';\n\tfont-weight: 700;\n\ttransition: 50ms all ease-out;\n\n\t&:hover {\n\t\topacity: 0.8;\n\t}\n\n\t&:active {\n\t\topacity: 1;\n\t}\n'
		])),
	function (props) {
		return props.theme.primaryColor || '#121212';
	},
	function (props) {
		return props.theme.backgroundColor || '#F1F1F1';
	}
));
var CardRightConnectingIcon = (exports.CardRightConnectingIcon = _styledComponents['default'].img(
	_templateObject22 ||
		(_templateObject22 = (0, _taggedTemplateLiteral2['default'])([
			'\n\twidth: 48px;\n\theight: 48px;\n\tmax-width: 48px;\n\tmax-height: 48px;\n\tmin-width: 48px;\n\tmin-height: 48px;\n\tborder-radius: 1rem;\n'
		]))
));
var WalletItem = (exports.WalletItem = _styledComponents['default'].div(
	_templateObject23 ||
		(_templateObject23 = (0, _taggedTemplateLiteral2['default'])([
			'\n\tdisplay: flex;\n\tpadding: 0.25rem 0.5rem;\n\tjustify-content: space-between;\n\talign-items: center;\n\tborder-radius: 0.5rem;\n\tborder: transparent solid 2px;\n\ttransition: 50ms all ease-out;\n\tuser-select: none;\n\n\t&:hover {\n\t\tbackground-color: ',
			';\n\t\tcursor: pointer;\n\t}\n\n\t&:active {\n\t\topacity: 0.75;\n\t}\n'
		])),
	function (props) {
		return (0, _colors.addOpacityToColor)(props.theme.primaryColor || '#121212', 0.08);
	}
));
var WalletItemConnected = (exports.WalletItemConnected = (0, _styledComponents['default'])(WalletItem)(
	_templateObject24 || (_templateObject24 = (0, _taggedTemplateLiteral2['default'])(['\n\tbackground-color: ', ';\n'])),
	function (props) {
		return (0, _colors.addOpacityToColor)(props.theme.primaryColor || '#121212', 0.08);
	}
));
var WalletItemTargeted = (exports.WalletItemTargeted = (0, _styledComponents['default'])(WalletItem)(
	_templateObject25 || (_templateObject25 = (0, _taggedTemplateLiteral2['default'])(['\n\tborder: ', ' solid 2px !important;\n'])),
	function (props) {
		return (0, _colors.addOpacityToColor)(props.theme.primaryColor || '#121212', 0.24);
	}
));
var WalletItemInfo = (exports.WalletItemInfo = _styledComponents['default'].div(
	_templateObject26 ||
		(_templateObject26 = (0, _taggedTemplateLiteral2['default'])([
			'\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tgap: 1rem;\n\tpadding: 0.5rem;\n'
		]))
));
var WalletItemInfoName = (exports.WalletItemInfoName = _styledComponents['default'].p(
	_templateObject27 ||
		(_templateObject27 = (0, _taggedTemplateLiteral2['default'])(['\n\tcolor: ', ';\n\ttext-transform: uppercase;\n\tfont-size: 1.25rem;\n\tmargin: 0;\n'])),
	function (props) {
		return props.theme.primaryColor || '#121212';
	}
));
var WalletItemInfoImage = (exports.WalletItemInfoImage = _styledComponents['default'].img(
	_templateObject28 ||
		(_templateObject28 = (0, _taggedTemplateLiteral2['default'])(['\n\tcolor: ', ';\n\tborder-radius: 50%;\n\twidth: 2rem;\n\theight: 2rem;\n'])),
	function (props) {
		return (0, _colors.addOpacityToColor)(props.theme.primaryColor || '#121212', 0.32);
	}
));
var WalletItemInfoIcon = (exports.WalletItemInfoIcon = (0, _styledComponents['default'])(_FaCheckCircle.FaCheckCircle)(
	_templateObject29 ||
		(_templateObject29 = (0, _taggedTemplateLiteral2['default'])(['\n\tcolor: ', ';\n\tborder-radius: 50%;\n\twidth: 1.25rem;\n\theight: 1.25rem;\n'])),
	function (props) {
		return (0, _colors.addOpacityToColor)(props.theme.primaryColor || '#121212', 0.32);
	}
));
var CardRightHeader = (exports.CardRightHeader = _styledComponents['default'].div(
	_templateObject30 ||
		(_templateObject30 = (0, _taggedTemplateLiteral2['default'])([
			'\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 2rem;\n\n\t@media (max-width: 480px) {\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\twidth: 100%;\n\t\tgap: 1rem;\n\t\tmargin-bottom: 1rem;\n\t}\n'
		]))
));
//# sourceMappingURL=styles.js.map
